export enum SwishErrorType {
  INVALID_PHONE_NUMBER = "INVALID_PHONE_NUMBER",
  AGE_LIMIT = "AGE_LIMIT",
  NOT_ENOUGH_FUNDS = "NOT_ENOUGH_FUNDS",
  ONGOING_REQUEST = "ONGOING_REQUEST",
  DEFAULT = "DEFAULT",
}
